import React, { Component } from 'react';
import { Modal, Button, Radio, Select, Icon, Checkbox, Spin } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';
import Cookies from 'js-cookie';

import { toggleDataExportVisibility } from '../../../actions/shipmentAction';
import {
  EXPORT_FILE_OPTIONS,
  FILE_TYPES,
  DEFAULT_FILE_TYPE,
  MAPPING_NAME
} from '../../../constants/shipment';
import { terms, preferredTime, ServiceType, FulfillOption as FulfillmentOptionConst } from '../../../constants';
import store from '../../../store';
import history from '../../../services/history';
import hanldeException from '../../../services/handleException';
import { getShipmentParams, renderListShipment, dateTimeCurrent } from '../../../services/helper';
import { confirmChangeItem } from '../../../services/dialog'
import { getExportShipmentData, getFileFormatExportShipment } from '../../../utils/shipment';
import { convertDateFromUTC } from '../../../services/dst';
import lang from '../../../languages/en';
import './style.css';

const RadioGroup = Radio.Group;
const { Option } = Select;

const radioStyle = {
  height: '35px',
  lineHeight: '35px',
  marginLeft: '20px',
  marginRight: '50px'
};
const radioGroupStyle = {
  marginTop: '10px'
}
const dropdownStyle = {
  width: '300px',
  marginTop: '15px',
}

// 30 days
const COOKIES_EXPIRE_DATE = 30;

class DataExport extends Component {
  constructor() {
    super()

    this.state = {
      selectedExportFile: EXPORT_FILE_OPTIONS.SELECTED,
      selectedFileType: Cookies.get('file_type') || DEFAULT_FILE_TYPE,
      selectedFileFormat: null,
      fileFormat: [],
      includeHeader: Cookies.get('include_header') === 'true',
      loading: false,
      csvFileData: [],
      fileUrl: '',
      disableIncludeHeader: true
    };
  }

  componentDidMount() {
    this.getFileFormat();
  }

  onCancel = () => {
    this.props.toggleDataExportVisibility({
      visibility: false
    })
  }

  onSelectExportFile = (e) => {
    this.setState({
      selectedExportFile: e.target.value
    });
  }

  onSelectFileFormat = (value) => {
    this.setState({
      selectedFileFormat: value
    }, () => {
      const { selectedFileFormat } = this.state;
      const isSelectAmazonOrRakuten = selectedFileFormat === MAPPING_NAME.Amazon
      || selectedFileFormat === MAPPING_NAME.Rakuten || selectedFileFormat === MAPPING_NAME.RakutenOld;
      this.setState(state => ({
        includeHeader: isSelectAmazonOrRakuten || state.includeHeader,
        disableIncludeHeader: isSelectAmazonOrRakuten
      }))
    })
  }

  onSelectFileType = (e) => {
    this.setState({
      selectedFileType: e.target.value
    })
  }

  storeUserSelection = () => {
    const { selectedFileType, selectedFileFormat, includeHeader } = this.state;

    Cookies.set('file_type', selectedFileType, { expires: COOKIES_EXPIRE_DATE });
    Cookies.set('file_format', selectedFileFormat, { expires: COOKIES_EXPIRE_DATE });
    Cookies.set('include_header', includeHeader, { expires: COOKIES_EXPIRE_DATE });
  }

  exportShipmentData = async () => {
    this.storeUserSelection();
    this.setState({
      loading: true,
      fileUrl: ''
    })

    const params = this.getExportFilterParams();
    try {
      await this.handleExport(params);
    } catch (error) {
      hanldeException(error)
    }
  }

  handleExport = async (params) => {
    this.setState({
      loading: true
    });

    try {
      const response = await getExportShipmentData(params);
      const { code, data } = response.data;
      switch(code) {
        case 10001:
          if(data.file) {
            this.setState({
              fileUrl: data.file
            })
          }
          return;
        case 320002:
          const confirmExportNewShipmentMessage = response.data.message;
          confirmChangeItem(
            confirmExportNewShipmentMessage,
            () => {
              this.exportNewShipment = true;
              this.handleExportWithNewData();
            },
            this.handleCancelExport
          )
          return;
        case 320006:
          const confirmMultiChannelMessage = response.data.message;
          confirmChangeItem(
            confirmMultiChannelMessage,
            () => {
              this.allowChannels = true;
              this.handleExportWithNewData();
            }
          )
          return;
        default:
          hanldeException(response)
      }
    } catch(error) {
      throw error
    } finally {
      this.setState({
        loading: false
      })
    }
  }

  // close form and reload shipment list
  handleCancelExport = () => {
    this.onCancel();
    renderListShipment(false, { Page: 1 });
  }

  handleExportWithNewData = () => {
    const params = this.getExportFilterParams();
    const newParams = {
      ...params,
      FormExport: {
        ...params.FormExport,
        DateFilter: this.exportNewShipment ? moment(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS') : params.FormExport.DateFilter,
        AllowShipmentChange: this.exportNewShipment,
        AllowChannels: this.allowChannels
      }
    };
    this.handleExport(newParams);
  }

  // get file name from firl url
  getExportFileName = () => {
    return /[^/]*$/.exec(this.state.fileUrl)[0];
  }

  getFileFormat = async () => {
    this.setState({
      loading: true
    })
    try {
      const response = await getFileFormatExportShipment();

      if (response.data.code === 10001) {
        const fileFormat = response.data.data.ExportMapping || [];
        const file_format = Cookies.get('file_format')
        let selectedFileFormat = null;

        // check if file format list get from server contains file_format stored
        if(fileFormat) {
          if(file_format && fileFormat.find(x => x.ID === +file_format)) {
            selectedFileFormat = +file_format;
          } else {
            selectedFileFormat = fileFormat[0].ID
          }
        }

        const isSelectAmazonOrRakuten = selectedFileFormat === MAPPING_NAME.Amazon
        || selectedFileFormat === MAPPING_NAME.Rakuten || selectedFileFormat === MAPPING_NAME.RakutenOld;
        this.setState(state => ({
          fileFormat,
          selectedFileFormat,
          includeHeader: isSelectAmazonOrRakuten || state.includeHeader,
          disableIncludeHeader: isSelectAmazonOrRakuten
        }))
      } else {
        hanldeException(response);
      }
    } catch (error) {
      hanldeException(error);
    } finally {
      this.setState({
        loading: false
      })
    }
  }

  getExportFilterParams = () => {
    const { selectedFileFormat, selectedExportFile, includeHeader, selectedFileType } = this.state;
    const searchParams = getShipmentParams(store.getState())
    const timeZone = -(new Date().getTimezoneOffset()/60);
    const filterDate = this.props.filterDate;

    const params = {
      ...searchParams,
      FormExport: {
        Ids: selectedExportFile === EXPORT_FILE_OPTIONS.ALL ? [] : searchParams.SelectedIds,
        FileFormatID: selectedFileFormat,
        IsIncludeHeader: includeHeader,
        FileExt: selectedFileType,
        DateFilter: moment(filterDate).format('YYYY-MM-DD HH:mm:ss.SSS'),
        TZ: timeZone,
        FulfillmentOption: this.props.fulfillment_option
      }
    }

    return params;
  }

  renderShipmentSelectBox = () => {
    const { listIdCheckedShipments, shipmentCount } = this.props;
    const checkedShipmentCount = listIdCheckedShipments.length;

    if (checkedShipmentCount > 0 && checkedShipmentCount !== shipmentCount) {
      return (
        <div className="top-content">
          <div className="header-content">
            <span className="bold-text">Which shipment(s) would you like to export?</span>
          </div>
          <div>
            <div>
              <div className="top-content-export-desc">
                <span className="gray-text">Only transmitted shipments can be exported. </span>
                <span className="gray-text">(</span>
                {
                  this.props.fulfillment_option === FulfillmentOptionConst.YAMATO.CODE ? 
                  <span className="red-text">Shipping In Process, Shipped, In Transit OR Delivered</span>
                  :
                  <span className="red-text">Shipped, In Transit OR Delivered</span>
                }
                
                <span className="gray-text">)</span>
              </div>
            </div>
            {this.renderExportFile()}
          </div>
        </div>
      );
    }

    return null;
  }

  renderExportFile = () => {
    const { shipments, listIdCheckedShipments, shippedShipmentCount, shipmentCount, fulfillment_option } = this.props;

    return (
      <RadioGroup
        onChange={this.onSelectExportFile}
        defaultValue={EXPORT_FILE_OPTIONS.SELECTED}
      >
        <Radio style={radioStyle} value={EXPORT_FILE_OPTIONS.SELECTED}>
          {`Export Selection Only: ${listIdCheckedShipments.length} shipment(s) in the current search result`}
        </Radio>
        <Radio style={radioStyle} value={EXPORT_FILE_OPTIONS.ALL}>
            {`Export All: ${shippedShipmentCount} shipment(s) in the current search result` }
        </Radio>
      </RadioGroup>
    )
  }

  renderFileTypeSelect = () => (
    <RadioGroup
      value={this.state.selectedFileType}
      onChange={this.onSelectFileType}
      style={radioGroupStyle}
    >
      {
        FILE_TYPES.map(type => (
          <Radio
            style={radioStyle}
            key={type.value}
            value={type.value}
          >
            {type.title}
          </Radio>
        ))
      }
    </RadioGroup>
  )

  renderFileFormatDropDown = () => {
    const { selectedFileFormat, fileFormat } = this.state;
    return (
      <Select
        value={selectedFileFormat}
        onChange={this.onSelectFileFormat}
        style={dropdownStyle}
      >
        {
          fileFormat.map(file => (
            <Option key={file.ID} value={file.ID}>{file.MappingName}</Option>
          ))
        }
      </Select>
    )
  }

  renderDownloadFile = () => {
    const { fileUrl } = this.state;
    return (
      <div className="download-file">
        <a href={`${process.env.REACT_APP_URL}${fileUrl}`}>
          <div className="file-container">
            <Icon
              style={{ fontSize: '60px' }}
              type="download"
              theme="outlined"
            />
            <div>Download</div>
          </div>
        </a>
        <div className="download-file-desc">{lang.shipment_download_description}</div>
      </div>
    )
  }

  onChangeIncludeFileHeader = (e) => {
    this.setState({
      includeHeader: e.target.checked
    })
  }

  renderMainContent = () => {
    const { includeHeader, csvFileData, disableIncludeHeader } = this.state;

    return (
      <div>
        <div className="modal-content">
          {this.renderShipmentSelectBox()}
          <div className="file-type-content">
            <div>
              <div className="header-content bold-text">Choose Export File Type</div>
              <div>
                {this.renderFileTypeSelect()}
              </div>
            </div>
          </div>
          <div className="file-format-content">
            <div className="header-content bold-text">Choose Export File Format</div>
            <div className="file-format-container">
              <div className="bottom-left">
                <div>
                  {this.renderFileFormatDropDown()}
                </div>
                <div className="check-box">
                  <Checkbox
                    disabled={disableIncludeHeader}
                    checked={includeHeader}
                    onChange={this.onChangeIncludeFileHeader}
                  >Include header row</Checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-component">
          <div className="fix-footer">
            <div className='navbar-cancel-export'>
              <Button className="cancel" onClick={this.onCancel}>Cancel</Button>
              <Button
                className="export-button"
                type="primary"
                onClick={this.exportShipmentData}
              >Download File</Button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { loading, fileUrl } = this.state;

    return (
      <Modal
        visible
        className="data-export-modal"
        footer={null}
        maskClosable={false}
        onCancel={this.onCancel}
      >
        <Spin tip="Loading" spinning={loading}>
          <div>
            <div className="modal-title">EXPORT DATA</div>
            {
              !fileUrl ? this.renderMainContent() : this.renderDownloadFile()
            }
          </div>
        </Spin>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    isDataExportVisible: state.shipmentReducer.dataExportModalVisibility,
    listIdCheckedShipments: state.shipmentReducer.listIdCheckedShipments,
    shipments: state.shipmentReducer.shipments,
    shippedShipmentCount: state.shipmentReducer.TransmittedCountByFilter,
    shipmentCount: state.shipmentReducer.shipment_count,
    loading: state.shipmentReducer.loading,
    filterDate: state.shipmentReducer.filterDate,
    fulfillment_option: state.shipmentReducer.fulfillment_option,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    toggleDataExportVisibility: payload => {
      dispatch(toggleDataExportVisibility(payload))
    }
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DataExport);



// WEBPACK FOOTER //
// ./src/containers/shipments/data-export/index.js